// extracted by mini-css-extract-plugin
module.exports = {"container":"chineseVersion_container__1Qgar","title":"chineseVersion_title__3EzSc","indent":"chineseVersion_indent__QR4tu","titleSpan":"chineseVersion_titleSpan__1I0J6"};